export { default } from './VideoBg';



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/VideoBg/index.js
 **/